import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * Finnaij: keeps the case-type switcher links pointing at the variant that matches the
 * currently selected Model / Case Finish. The links are rendered by Liquid
 * (blocks/case-type-switcher.liquid); on variant change the variant picker fetches the
 * re-rendered section, and this component morphs itself from that HTML.
 *
 * Without JavaScript the links still work; they just keep the initially selected model.
 *
 * @extends {Component}
 */
class CaseTypeSwitcher extends Component {
  /** @type {HTMLElement | null} */
  #target = null;

  connectedCallback() {
    super.connectedCallback();
    this.#target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"]');
    this.#target?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#target?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#target = null;
  }

  /**
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    event.promise
      .then(({ detail }) => {
        if (!detail?.html || !this.id) return;
        if (detail.productId && detail.productId !== this.dataset.productId) return;

        const updated = detail.html.getElementById(this.id);
        if (updated instanceof HTMLElement) morph(this, updated);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[case-type-switcher] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('case-type-switcher')) {
  customElements.define('case-type-switcher', CaseTypeSwitcher);
}
